import Vue from "vue"
Vue.mixin({
  methods: {
    $msg(message, type = "info") {
      this.$message({
        message,
        type
      })
    },
    $success(message) {
      this.$msg(message, "success")
    },
    $error(message) {
      this.$msg(message, "error")
    },
    $warn(message) {
      this.$msg(message, "warning")
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixin/message.js